export default "__VITE_ASSET__CTIRF_Mm__"